import { deleteData, getData, postData, postFormData } from './config/ApiCalls';

import { apiSettings } from '../Settings';

export const getOrganizationUser = async () => {
  try {
    const response = await getData(`${apiSettings.users.getOrganizationUser}`);
    return response;
  } catch (error) {
    return null;
  }
};
